import {
  GroupedAttributeFilterSection,
  GroupedAttributeFilterSection_AttributeGroup,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/filter_section.types';
import {useCallback, useMemo} from 'react';

interface Props {
  data: GroupedAttributeFilterSection;
  activeFilters: Map<string, Array<string> | undefined>;
  setFilter: (filterData: {
    filterId: string;
    filterSection: string;
    filterSlug?: string;
  }) => void;
}

export const useGroupedAttributesSection = ({
  data,
  setFilter,
  activeFilters,
}: Props) => {
  const {groups, slug} = data;

  const normalizedGroups = useNormalizeGroups(groups);

  const activeSlugFilters = activeFilters.get(slug) ?? [];

  const handleItemClick = useCallback(
    (id: string, itemSlug?: string) => {
      setFilter({
        filterId: id,
        filterSection: slug,
        filterSlug: itemSlug,
      });
    },
    [setFilter, slug],
  );

  return {
    activeSlugFilters,
    normalizedGroups,
    handleItemClick,
  };
};

const useNormalizeGroups = (
  itemGroups: Array<GroupedAttributeFilterSection_AttributeGroup>,
) =>
  useMemo(
    () =>
      itemGroups.map(itemGroup => ({
        ...itemGroup,
        items: itemGroup.values.map(item => ({
          ...item,
          count: item.productCount,
          id: `${item.id}`,
          slug: item.slug,
        })),
      })),
    [itemGroups],
  );
